// OsnovaContext — контракт, который получает каждый продукт при монтировании.
// Обычный TS (без React), чтобы фронт продукта мог импортировать типы без React в зависимостях.
// Хелпер для продуктов (СВОД п.32) — вынесен из инлайна, чтобы не дублировать .includes()
// в каждом месте использования и оставаться тестируемым без React.
export function isProductInstalled(installedProducts, slug) {
    return !!installedProducts && installedProducts.includes(slug);
}
// Внутристраничная шина событий (переживает перемонтирование продукта).
const _listeners = new Map();
export const sharedEventBus = {
    emit(name, data) {
        _listeners.get(name)?.forEach((cb) => cb(data));
    },
    on(name, cb) {
        if (!_listeners.has(name))
            _listeners.set(name, new Set());
        _listeners.get(name).add(cb);
        return () => { _listeners.get(name)?.delete(cb); };
    },
};
export function createOsnovaContext(deps) {
    return {
        module: deps.module,
        cap: deps.cap,
        view: deps.view,
        theme: deps.theme,
        locale: deps.locale,
        numFmt: deps.numFmt,
        user: deps.user,
        permissions: deps.permissions,
        nav: { open: deps.navigate, setBreadcrumbs: deps.setBreadcrumbs },
        modal: { open: deps.openModal, close: () => { } },
        events: deps.emitter,
        section: deps.section,
        onSections: deps.onSections,
        onSectionChange: deps.onSectionChange,
        onCrumbs: deps.onCrumbs,
        installedProducts: deps.installedProducts,
        productText: deps.productText,
        // Рабочий ready() подставляет ModuleHost при монтировании экрана.
        screen: { ready: () => { } },
    };
}
